module.exports = __webpack_public_path__ + "static/media/womp.a1ffaf2d.mp3";